// The status vocabulary the Employee Reviews listings and the completed-review record share.
// The API returns a status as an enum name; the UI owns the label and the colour, so every
// consumer resolves both from here rather than holding its own copy of them.
//
// Statuses render as plain coloured text per the design, reusing the existing text-intent
// classes (and Blueprint's muted grey for Due later, which carries no intent of its own).

export const overdueStatusBand = { label: "Overdue", className: "text-intent-danger" };
export const dueSoonStatusBand = { label: "Due soon", className: "text-intent-warning" };
export const dueLaterStatusBand = { label: "Due later", className: "bp6-text-muted" };
export const awaitingSignOffStatusBand = { label: "Awaiting Sign Off", className: "text-intent-warning" };
export const completedStatusBand = { label: "Completed", className: "text-intent-success" };

// The completed listing's sign-off column describes the signature rather than the review, so
// it names the finished state "Complete" against the review's own "Completed".
export const completeSignOffStatusBand = { label: "Complete", className: "text-intent-success" };

// The urgency bands a review that has not been completed can be in, in the order the API's
// status enum declares them. A listing of pending reviews offers exactly these as filters -
// its search rejects the completed-side statuses.
export const pendingStatusBands = {
    Overdue: overdueStatusBand,
    DueSoon: dueSoonStatusBand,
    DueLater: dueLaterStatusBand
};
